const CALIFORNIA_RESTRICTED_MATERIALS = new Set([
    "Z232KW-42",
    "Z242KW-48",
    "Z252KW-54",
    "Z242KH-48",
    "Z252KH-54",
    "Z411KWNC-48",
    "Z412KWNC-48",
    "Z421KWNC-54",
    "Z422KWNC-54",
    "Z421KWNC-60",
    "Z422KWNC-60",
    "Z452KWi-54",
    "Z452KWTi-60",
    "Z724XKWNC-48",
    "Z724XKWNC-54",
    "Z726XKWNC-60",
    "Z723KH-3-60",
    "Z724KHNC-54",
    "Z725KHNC-60",
    "Z751KWi-48",
    "Z781KWi-54",
    "Z781KWiTW-54",
    "Z781KWiTW-60",
    "Z781KWTi-60",
    "ZG222",
    "ZG227",
    "ZG327",
    "SZ19NC-36-2",
    "SZ22NC-48-2",
    "SZ26NC-52-2",
    "SZ26NC-61-2",
    "WHF14NC-36-2",
    "WHF15NC-48-2",
    "WHF19NC-52-2",
    "T2290KWNC-42",
    "T2290KWTNC-48",
]);

export default function CaliforniaDisclaimer({ product, classNames = '', truncated = false }) {
    const material = product?.Tractor?.Material;

    if (!material || !CALIFORNIA_RESTRICTED_MATERIALS.has(material)) {
        return null;
    }

    // Show the disclaimer
    return (
        <div className={classNames}>{truncated ? 'Not available in California' : 'Not available for sale in California. This product may be subject to restrictions under California law. The California Air Resources Board (CARB) has implemented regulations limiting the sale of new (MY24 and newer) small off-road engines (SORE), including many gasoline-powered engines used in outdoor power equipment. As a result, certain gasoline-powered models may not be sold, shipped, or offered for use in the State of California. CARB classifies small offroad engines as spark-ignition engines which are 25 horsepower or less'}</div>
    );
}
